/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";
import * as RichtextVideoFacet from "../richtext/videoFacet.defs.js";
import * as StreamDefs from "../defs.defs.js";
import * as MetadataContentWarnings from "../metadata/contentWarnings.defs.js";
import * as MetadataContentRights from "../metadata/contentRights.defs.js";
import * as VodDraftDefs from "./draftDefs.defs.js";

const $nsid = "place.stream.vod.updateDraft";

export { $nsid };

export const $params = /*#__PURE__*/ l.params();

export type $Params = l.InferOutput<typeof $params>;

export const $input = /*#__PURE__*/ l.jsonPayload({"uri":/*#__PURE__*/ l.string(),"title":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"maxLength":1400,"maxGraphemes":140})),"description":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"maxLength":50000,"maxGraphemes":5000})),"descriptionFacets":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.array(/*#__PURE__*/ l.ref<RichtextVideoFacet.Main>((() => RichtextVideoFacet.main) as any), )),"thumb":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.blob({"accept":["image/*"],"maxSize":1000000})),"activity":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.typedUnion([/*#__PURE__*/ l.typedRef<StreamDefs.ActivityGame>((() => StreamDefs.activityGame) as any),/*#__PURE__*/ l.typedRef<StreamDefs.ActivityLabel>((() => StreamDefs.activityLabel) as any)], false)),"tags":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.array(/*#__PURE__*/ l.string({"maxLength":640,"maxGraphemes":64}), {"maxLength":10})),"contentWarnings":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.ref<MetadataContentWarnings.Main>((() => MetadataContentWarnings.main) as any)),"contentRights":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.ref<MetadataContentRights.Main>((() => MetadataContentRights.main) as any))});

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>;
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>;

export const $output = /*#__PURE__*/ l.jsonPayload({"draft":/*#__PURE__*/ l.ref<VodDraftDefs.DraftView>((() => VodDraftDefs.draftView) as any)});

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>;
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $output, B>;

/** Update a draft VOD's editable metadata. Server-authoritative fields (source, durationMs, status) are preserved. Editing is allowed in any status, so the user can pre-fill metadata while processing. All fields except uri are optional (partial update). */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output, ["NotFound"]);

export { main };

export const $lxm = $nsid;
